<h2 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" cdkDragHandle class="tt-secondary-background">
    <span ttTranslateWord="tt_grid_drill_down"></span>
</h2>
<mat-dialog-content style="display: flex; padding: 0; height: 100%; flex: 1; max-height: none; font-family: var(--tt-body-font-family)">
    <tt-grid class="col-xs-12 sp-0" [(ttOptions)]="grid" (ttRowDataChange)="hasBeenEdited = true" (ttReady)="onReady()"></tt-grid>
</mat-dialog-content>

<mat-dialog-actions align="end"> </mat-dialog-actions>
